var map = {
	"./champions-trophy-logo-colour.webp": 43903,
	"./csa-one-day-cup-logo-colour.webp": 22674,
	"./csa-t20-challenge-logo-colour.webp": 45178,
	"./icc-men's-t20-world-cup-2026-logo-colour.png": 95831,
	"./ipl-cricket-logo-colour.png": 90776,
	"./ipl-cricket-logo-colour.webp": 94565,
	"./sa-20-logo-colour.png": 64000,
	"./test-championship-logo-colour.webp": 42230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52541;